module.exports = __webpack_public_path__ + "img/secured-dissemination.6943d456.png";